import React from 'react';
import cmsData from 'Lib/cmsData';
import GeneralPage from '../components/general-page';
import FourOhFour from '../components/four-oh-four';

const Page = (props) => {
  if (!props.data) return <FourOhFour statusCode={404} />;

  return (
    <GeneralPage pageFields={props.data.fields} />
  );
};

Page.getInitialProps = async ({ query }) => {
  const data = await cmsData({
    content_type: 'generalPage',
    'fields.pageSlug': query.slug,
  });

  return { data: data && data[0] };
};

export default Page;
